<template lang="pug">
	.section-container
		section-company
		section-form(ref="sectionform")
</template>

<script>
import ModalComponent from '../components/ModalComponent.vue'
import SectionForm from '../components/sections/SectionForm.vue'
import SectionCompany from '../components/sections/SectionCompany.vue'
import { ChevronRightIcon } from 'vue-feather-icons'

export default {
	components: {
		ModalComp: ModalComponent,
		SectionForm,
		SectionCompany,
		ChevronRightIcon
	},
	data() {
		return {
			videoPopup: false,
		}
	},
	computed: {
		language() {
			return this.$t('locale.lang')
		}
	},
	mounted() {
		this.$meta().setOptions({ title: this.$t("title.about") })
		document.getElementsByTagName("BODY")[0].classList.add('page-header')
	},
	watch: {
		language() {
			if (this.videoPopup) {
				this.$refs.modalvideo.close()
				this.videoPopup = false
			}
		}
	}
}
</script>
